"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pipe = function (initialValue) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var finalValue = args.reduce(function (value, func) {
        var nextValue = func(value);
        return nextValue;
    }, initialValue);
    return finalValue;
};
exports.default = pipe;
//# sourceMappingURL=index.js.map